module.exports = __webpack_public_path__ + "img/emoji_16.60ace81f.png";